import React, { useState } from 'react';
import Brand from './Brand';
import HeaderNav from './HeaderNav';
import DeleteAccountDialog from './DeleteAccountDialog';
import { planLabel } from '../utils/planLabels';

const ProfilePage = ({ user, theme, onThemeChange, preferenceError, onBack, onLogout, onDeleted = onLogout }) => {
  const [deleting, setDeleting] = useState(false);
  return (
  <div className="app-shell">
    <header className="topbar">
      <Brand href="/" onClick={(event) => {
        if (onBack && !event.metaKey && !event.ctrlKey && !event.shiftKey && event.button === 0) {
          event.preventDefault();
          onBack();
        }
      }} />
      <HeaderNav user={user} onWorkspace={onBack} onLogout={onLogout} />
    </header>
    <main className="workspace profile-workspace">
      <section className="workspace-intro">
        <div><p className="eyebrow">Your account</p><h1>Profile.</h1></div>
        <p className="intro-copy">Make your research workspace feel like yours.</p>
      </section>
      <section className="panel profile-panel">
        <div className="panel-heading">
          <div><p className="eyebrow">Personal settings</p><h2>Appearance</h2></div>
          <span className="profile-account-plan">{planLabel(user?.plan, user?.plan_label || 'Account')}</span>
        </div>
        <p className="muted">Choose how Rebellionaire.AI looks on your devices.</p>
        {preferenceError && <div className="error-box profile-error" role="alert">Could not sync your appearance preference: {preferenceError}</div>}
        <fieldset className="theme-options">
          <legend>Color theme</legend>
          <label className={`theme-option ${theme === 'dark' ? 'selected' : ''}`}>
            <input type="radio" name="theme" value="dark" checked={theme === 'dark'} onChange={() => onThemeChange('dark')} />
            <span className="theme-preview theme-preview-dark" aria-hidden="true"><span /></span>
            <span><strong>Dark</strong><small>Focused, low-glare workspace</small></span>
            <span className="theme-option-check" aria-hidden="true">{theme === 'dark' ? '✓' : ''}</span>
          </label>
          <label className={`theme-option ${theme === 'light' ? 'selected' : ''}`}>
            <input type="radio" name="theme" value="light" checked={theme === 'light'} onChange={() => onThemeChange('light')} />
            <span className="theme-preview theme-preview-light" aria-hidden="true"><span /></span>
            <span><strong>Light</strong><small>Classic bright workspace</small></span>
            <span className="theme-option-check" aria-hidden="true">{theme === 'light' ? '✓' : ''}</span>
          </label>
        </fieldset>
        <p className="profile-account-email">{user?.email || user?.username || 'Signed-in account'}</p>
        <p className="profile-storage-note">Your theme choice is saved to your account and follows you across devices.</p>
      </section>
      <section className="panel profile-panel profile-delete-panel">
        <div className="panel-heading"><div><p className="eyebrow">Account management</p><h2>Delete account</h2></div></div>
        <p className="muted">Permanently remove your login and personal settings, rather than switching to Free or Client. Linked paid subscriptions will be cancelled.</p>
        <button className="danger-button" type="button" onClick={() => setDeleting(true)}>Delete my account</button>
      </section>
    </main>
    {deleting && <DeleteAccountDialog onClose={() => setDeleting(false)} onDeleted={onDeleted} />}
  </div>
  );
};

export default ProfilePage;
